import { CreationToolProps, getUploadedSearchAndSelectEntry } from "@kaltura/mediaspace-shared-search-and-select";
import { UploadMediaContainer, UploadMediaContainerProps } from "@kaltura/mediaspace-shared-upload";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { useState } from "react";
import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";

export interface UploadCreationToolProps
    extends CreationToolProps,
        Omit<UploadMediaContainerProps, "onEntryCreated" | "onSubmit"> {}

/**
 * Upload creation tool for the quiz creation page - connect the upload component with creation tool flow
 */
export const UploadCreationTool = (props: UploadCreationToolProps) => {
    const {
        onEntryCreated,
        onCanSaveForm,
        onEntryReady,
        onUploadCancelled,
        onReadyForPublish,
        onSubmitStarted,
        onEditFormShown,
        onSubmit,
        formId,
        ...rest
    } = props;

    const [finishedUploading, setFinishedUploading] = useState(false);

    const handleEntryCreated = (entry: KalturaMediaEntry) => onEntryCreated?.(getUploadedSearchAndSelectEntry(entry));

    const handleSubmit = (entry: KalturaMediaEntry) => {
        // Proceed to selecting the entry for quiz only if the upload has finished
        if (finishedUploading) {
            onSubmit?.(getUploadedSearchAndSelectEntry(entry));
        }
    };

    return (
        <UploadMediaContainer
            {...rest}
            showBackButton={false}
            showTitle={false}
            publishEnabled={false}
            singleUpload={true}
            showEditFormButtons={true}
            showCancelButton={false}
            allowSaveUntouched={true}
            onEntryFinishedUploading={() => setFinishedUploading(true)}
            saveButtonLabel={finishedUploading ? translate("Save & Select") : translate("Save")}
            onSubmit={handleSubmit}
            onEntryCreated={handleEntryCreated}
            // Pass-through creation tool auto-props
            onCanSaveForm={onCanSaveForm}
            onEntryReady={onEntryReady}
            onUploadCancelled={onUploadCancelled}
            onReadyForPublish={onReadyForPublish}
            onSubmitStarted={onSubmitStarted}
            onEditFormShown={onEditFormShown}
            formId={formId}
        />
    );
};
